import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { TokenService } from 'app/token/token.service';
import { ApplicationService } from './application.service';

@Injectable()
export class ApplicationResolveService implements Resolve<any> {
    constructor(private applicationService: ApplicationService, private tokenService: TokenService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return new Promise((resolve, reject) => {
            if (route.queryParams.LoanApplicationId) {
                this.applicationService.getOrderDetails(route.queryParams.LoanApplicationId).subscribe(applicationResponse => {
                    this.applicationService.saveApplication(applicationResponse);
                    this.applicationService.getFlowType(route.queryParams.merchantid).subscribe((flow) => {
                        if (flow.isCJMAllowed) {
                            this.tokenService.setCJMFlag(true);
                        }
                    });
                    this.applicationService.getMerchantRoutes(applicationResponse.MerchantName.trim().toLowerCase()).subscribe(routesResponse => {
                        this.applicationService.setRouteConfigs(routesResponse);
                        resolve(applicationResponse);
                    }, error => {
                        return this.applicationService.getMerchantRoutes().subscribe(routesResponse => {
                            this.applicationService.setRouteConfigs(routesResponse);
                            resolve(applicationResponse);
                        });
                    });
                }, error => {
                    resolve(null);
                });
            } else {
                resolve(null);
            }
        });
    }
}
